import React from "react";
import CardCategory from "./CardCategory";

function Category() {
  return (
    <div className="container mx-auto py-4 px-4 mt-10 lg:px-[5%]" id="category">
      {/* Responsive: centré sur mobile, en ligne sur écran large */}
      <div className="flex flex-col sm:flex-row sm:justify-between items-center sm:items-start text-center sm:text-left gap-4 sm:gap-0 mb-4">
        <h1 className="text-radar-700 text-xl sm:text-2xl md:text-3xl font-semibold">
          Ressources pédagogiques
        </h1>
      </div>
      <p>
        Toutes les ressources sont accessibles en cliquant. Pour en faciliter la
        consultation, une brève présentation des différents contenus vous est
        proposée. Dans chaque ressource, vous trouverez un résumé plus complet.
      </p>

      {/* Affichage du composant CardCategory avec la gestion de showMore */}
      <CardCategory />
    </div>
  );
}

export default Category;
